// extracted by mini-css-extract-plugin
export default {"sort":"sort_sort__e3+ri","label":"sort_label__iRooe","span":"sort_span__DUMEs","sort_poput":"sort_sort_poput__-TLbU","active":"sort_active__s1lz+"};